import { render, staticRenderFns } from "./asset.vue?vue&type=template&id=5cceb31e&scoped=true"
import script from "./asset.vue?vue&type=script&lang=js"
export * from "./asset.vue?vue&type=script&lang=js"
import style0 from "./asset.vue?vue&type=style&index=0&id=5cceb31e&prod&lang=scss&scoped=true"
import style1 from "./asset.vue?vue&type=style&index=1&id=5cceb31e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cceb31e",
  null
  
)

export default component.exports